module.exports = __webpack_public_path__ + "img/banner3优秀成果 手机端.117d7add.jpg";